var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLivingLearning139(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,80.27,107.76,29.9,182.53,80M52,67.6V173.25H164V67.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.36,87.82v47.6s17.85-9.27,36.51,0l-.41-47.19S92.64,75.32,72.36,87.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.91,87.82v47.6s-17-9.27-35.68,0l-.43-47.19S123.62,75.32,143.91,87.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.36,146.39s17-10.62,35.71,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.91,146.39s-17-10.62-35.71,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingLearning139);
export default __webpack_public_path__ + "static/media/LIVING_LEARNING_139.406cb41ba682acc1669d3467fb26eae2.svg";
export { ForwardRef as ReactComponent };